'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useFundingEntryWarmup } from '@morfi/onramp-sdk/react';
import type { ReactNode } from 'react';
import { useCurrencyStore } from '@/stores/currency';
export function FundingEntryWarmup(t0) {
  const $ = _c(5);
  const {
    client,
    open,
    prewarm,
    mode,
    children
  } = t0;
  const currency = useCurrencyStore(_temp);
  let t1;
  if ($[0] !== currency || $[1] !== mode || $[2] !== open || $[3] !== prewarm) {
    t1 = {
      enabled: prewarm,
      active: open,
      mode,
      currency,
      surface: "web"
    };
    $[0] = currency;
    $[1] = mode;
    $[2] = open;
    $[3] = prewarm;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const entered = useFundingEntryWarmup(client, t1);
  return entered ? children : null;
}
function _temp(state) {
  return state.currency;
}